import type { ValidatorConstraintInterface } from "class-validator";
import { ValidatorConstraint, isUUID } from "class-validator";

@ValidatorConstraint({ async: false })
export class IsUUIDOrNull implements ValidatorConstraintInterface {
    validate(value: any) {
        return value === null || isUUID(value, "4");
    }

    defaultMessage() {
        return "Value should be UUIDv4 a string or null";
    }
}
